import { render, staticRenderFns } from "./UserSettingsDialog.vue?vue&type=template&id=7471bacf&"
import script from "./UserSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./UserSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports